import type { VariantType } from "@shared/graphql.types";

export const testPDPs = {
  "youthbomb-body-concentrate": {
    breadcrumbs: [
      {
        url: "/shop/bestsellers",
        label: "Shop"
      },
      {
        url: "/shop/body",
        label: "Bodycare"
      },
      {
        url: "/shop/body/body-treatments",
        label: "Body Treatments"
      },
      {
        label: "Body Concentrate"
      }
    ]
  },
  "youthbomb-double-retinol-skin-overhaul-serum": {
    breadcrumbs: [
      {
        url: "/shop/bestsellers",
        label: "Shop"
      },
      {
        url: "/shop/skincare",
        label: "Skincare"
      },
      {
        url: "/shop/skincare/serum",
        label: "Serum & Drops"
      },
      {
        label: "Double Retinol Serum"
      }
    ]
  },
  "lash-fuel-peptide-serum": {
    breadcrumbs: [
      {
        url: "/shop/bestsellers",
        label: "Shop"
      },
      {
        url: "/shop/makeup",
        label: "Makeup"
      },
      {
        url: "/shop/makeup/eyes",
        label: "Eyes"
      },
      {
        url: "/shop/makeup/eyes/mascara",
        label: "Mascara"
      },
      {
        label: "Advanced Peptide Serum"
      }
    ]
  },
  "plantastic-micropeeling-super-drops": {
    breadcrumbs: [
      {
        url: "/shop/bestsellers",
        label: "Shop"
      },
      {
        url: "/shop/skincare",
        label: "Skincare"
      },
      {
        url: "/shop/skincare/serum",
        label: "Serum & Drops"
      },
      {
        label: "Micropeeling Super Drops"
      }
    ]
  },
  "uber-youth-neck-and-chest-serum-spray": {
    breadcrumbs: [
      {
        url: "/shop/bestsellers",
        label: "Shop"
      },
      {
        url: "/shop/skincare",
        label: "Skincare"
      },
      {
        url: "/shop/skincare/neck",
        label: "Neck & Décolletage"
      },
      {
        label: "Neck and Chest Serum Spray"
      }
    ]
  }
};

export function withTestData(variant: VariantType): VariantType {
  if (variant.slug && variant.slug in testPDPs) {
    return {
      ...variant,
      ...testPDPs[variant.slug]
    };
  }
  return variant;
}
